const featureThis = "whereUseContent";

function featureIntro(rootEl = document) {
  const featuring = Array.from(rootEl.getElementsByClassName(featureThis));

  featuring.forEach((element) => {
    element.addEventListener("mouseover", (event) => {
      event.currentTarget.classList.add("selected");
    });
    element.addEventListener("mouseout", (event) => {
      event.currentTarget.classList.remove("selected");
    });
  });
}

window.addEventListener("DOMContentLoaded", () => {
  featureIntro();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    featureIntro(event.target, true)
  );
  document.addEventListener("shopify:section:reorder", () =>
    featureIntro(document, true)
  );
}
